import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { Button } from '@mui/material'
import { useTranslate, TranslatedTextType } from '../../../hooks/shared'

interface RFFCustomSubmitBtnProps {
  pristine: boolean
  submitting: boolean
  valid: boolean
  buttonText?: TranslatedTextType
  classesCustom?: string
  dataTestid?: string
}

const useStyles = makeStyles()((theme: Theme) => ({
  //TODO: REUSED!
  buttonSubmit: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.contrastText,
    ...theme.brand.assets.layout?.ctaOverride,
    fontSize: '1rem',
  },
}))

const RFFCustomSubmitBtn: FC<RFFCustomSubmitBtnProps> = ({
  submitting,
  pristine,
  valid,
  buttonText,
  classesCustom,
  dataTestid,
}) => {
  const { classes, cx } = useStyles()
  const { t } = useTranslate()

  return (
    <Button
      variant='contained'
      type='submit'
      fullWidth
      disableElevation
      className={cx(classesCustom, classes.buttonSubmit)}
      disabled={submitting || pristine || !valid}
      data-testid={dataTestid}
    >
      {buttonText ? buttonText : t(`next`)}
    </Button>
  )
}

export default RFFCustomSubmitBtn
